<template>
  <div>
    <v-row>
      <v-col cols="12" md="6">
        <strong>Workflow:</strong> {{ workflow.workflow_nome }}
      </v-col>
      <v-col cols="12" md="6">
        <strong>Provedor:</strong> {{ workflow.provedor_nome }}
      </v-col>
      <v-col cols="12" md="6">
        <strong>Regional:</strong> {{ workflow.regional_inst }}
      </v-col>
      <v-col cols="12" md="6">
        <strong>UF:</strong> {{ workflow.provedor_uf }}
      </v-col>
      <v-col cols="12" md="6">
        <strong>Tipo de Solicitação:</strong> {{ workflow.tipo_solicitacao }}
      </v-col>
      <v-col cols="12" md="6">
        <strong>Tipo de Serviço:</strong> {{ workflow.tipo_servico }}
      </v-col>
      <v-col cols="12" md="6">
        <strong>Código do Circuito:</strong> {{ workflow.cod_circuito }}
      </v-col>
      <v-col cols="12" md="6">
        <strong>Aging:</strong> {{ workflow.aging_dias }}
      </v-col>
      <v-col cols="12" md="6">
        <strong>Dentro do SLA:</strong> {{ workflow.dentro_sla ? 'Sim' : 'Não' }}
      </v-col>
      <v-col cols="12" md="6">
        <strong>Fechamento:</strong> {{ workflow.finalized_at }}
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'WorkflowInstalacaoDetalhesComponent',
  props: {
    workflow: {
      type: Object,
      required: true
    }
  }
}
</script>
